import partition from 'lodash/partition';
import isNil from 'lodash/isNil';
import set from 'lodash/set';

const addFallbackNames = fallbackName => (member, i) => set(member, 'profile.fullName', `${fallbackName} #${i + 1}`);

export default ({ group, noFullNameAvailableFallback }) => {
  const [noNameMembers, namedMembers] = partition(
    group,
    ({ profile: { fullName } }) => isNil(fullName),
  );

  return [
    ...namedMembers,
    ...noNameMembers.map(addFallbackNames(noFullNameAvailableFallback)),
  ];
};
